module.exports = __webpack_public_path__ + "img/oesenabstand.8cb54a40.svg";